import React from 'react';
import { graphql } from 'gatsby';
import SvgSafeGatsbyImage from '@atoms/SvgSafeGatsbyImage';
import Masonry from 'react-masonry-css';
import Container from '@atoms/Container';
import paddingDefault from '@utils/paddingDefault';
import apCaseOnlyTitleTags from '@utils/apCaseOnlyTitleTags';
import { colors } from '../primitives/colors';

const breakpointColumnsObj = {
    default: 3,
    700: 2,
    500: 1
};

const Gallery = ({ data }) => {

    const { heading, subheading, images } = data;

    return (
        <section css={paddingDefault()}>
            <Container>
                {(heading || subheading) && (
                    <header css={styles.header}>
                        {heading && <h2 css={styles.heading}>{apCaseOnlyTitleTags(heading)}</h2>}
                        {subheading && (
                            <p css={styles.subheading}>{apCaseOnlyTitleTags(subheading)}</p>
                        )}
                    </header>
                )}
                <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="my-masonry-grid"
                    columnClassName="my-masonry-grid-column">
                    {images.map((image, idx) => (
                        <SvgSafeGatsbyImage
                            key={idx}
                            image={image}
                            alt={image.description}
                        />
                    ))}
                </Masonry>
            </Container>
        </section>
    );
};

const styles = {
    header: {
        marginBottom: "3rem",
        textAlign: "center"
    },
    heading: {
        fontSize: '42px'
    },
    subheading: {
        color: colors.primaryOrange
    }
};

export const query = graphql`
  fragment GalleryData on CmsPageBuilderBlocks {
    gallery {
      heading
      subheading
      images {
        filename
        title
        url
        description
        contentStackAsset(width: 1440)
      }
    }
  }
`;

export default Gallery;
